<template>
    <div class="animated fadeIn">
        <!-- <div class="manage-job-section">
            <div class="black-strip-head d-lg-flex d-sm-flex align-items-center">
                <h3 class="mr-auto">{{payslip['payslip_number'] }}</h3>
            
            </div>
        </div> -->
        <div class="dashboard-headline">
            <h1>{{payslip['payslip_number'] }}</h1>
      </div>
        <div v-if="items.length > 0" >
            <div v-for="item in items" :key="item">
                <div  class="profile-section p-lg-5 p-3  view_audit_top_div log_box_shadow">
                    <div class="profile-box pl-0">
                        <div class="profile-detail">
                            <ul class="pl-0 mb-0 log_ul">
                                <li v-if="item.url" class="pl-0">
                                    <p><b>Url</b>- <i> <a :href="item.url" target="_blank" style="color: blue;" class="log_li">{{item.url}}</a> </i></p>
                                </li>
                                <li v-if="item.user_id" class="pl-0 ">
                                    <p><b>Freelancer</b>- <i class="log_li"> {{(item.user_id != null ? item.user_id.full_name : '-') | capitalize}} </i></p>
                                </li>
                                <li v-if="item.log" class="pl-0">
                                    <p><b>Log</b>- <i> 
                                        <!-- {{item.log | capitalize}} -->
                                         <b-table
                                            ref="datatableAll"
                                            show-empty
                                            striped
                                            hover
                                            responsive
                                            :items="[JSON.parse(item.log)]"
                                            :fields="fields_log"
                                            class="log_table_bill new_layout_table_like_v1 common_small_font_table new_jbs_full_over_flow common_border_top_right_left_radius_4px  mt-4"
                                        >
                                            <template #cell()="{ value }">
                                                {{ value !== 0 && !value ? '-' : value }}
                                            </template>
                                            <template #cell(url)="data">
                                                <a :href="data.value" target="_blank" rel="noopener noreferrer">View PDF</a>
                                            </template>
                                        </b-table>
                                    </i></p>
                                </li>
                                <li v-if="item.generated_by" class="pl-0">
                                    <p><b>Generated By</b>- <i class="log_li"> {{(item.generated_by != null ? item.generated_by.full_name : '-') | capitalize}}</i></p>
                                </li>
                                <li v-if="item.created_at" class="pl-0">
                                    <p><b>Created At</b>- <i class="log_li"> {{item.created_at | moment}}</i></p>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                </div>
                <br>
            </div>
        </div>
        <div v-else> No Data Found</div>

        
    </div>
</template>
<script>
import { POST_API, GET_API} from "../../../store/actions.type";
import moment from "moment";
import JwtService from "../../../common/jwt.service";
import Vue from 'vue';

export default {

    data() {
        return {
            fields: [
                { key: 'process', label: 'Process', sortable: true, thStyle:  {width: '5%'}},
                { key: 'url', label: 'URL', sortable: true, thStyle:  {width: '5%'}},
                { key: 'process_log', label: 'Process Log', sortable: true, thStyle:  {width: '5%'}},
                { key: 'status', label: 'Status', sortable: true, thStyle:  {width: '5%'}},
                { key: 'updated_on', label: 'Updated On', sortable: true, thStyle:  {width: '7%'} },
                { key: 'updated_by', label: 'Updated By', sortable: true, thStyle:  {width: '5%'}},
            ],
            fields_log: [
                { key: 'id', label: 'ID', sortable: true, thStyle:  {width: '20%'}},
                { key: 'user_id', label: 'User ID', sortable: true, thStyle:  {width: '20%'}},
                { key: 'job_ids', label: 'Job ID', sortable: true, thStyle:  {width: '20%'}},
                { key: 'payslip_number', label: 'Payslip Number', sortable: true, thStyle:  {width: '20%'}},
                { key: 'start_date', label: 'Start Date', sortable: true, formatter: 'formatDate', thStyle:  {width: '20%'}},
                { key: 'end_date', label: 'End Date', sortable: true, formatter: 'formatDate', thStyle:  {width: '20%'}},
                { key: 'payslip_generated_on', label: 'Payslip Generated On', sortable: true, formatter: 'formatDate', thStyle:  {width: '20%'}},
                { key: 'url', label: 'URL', sortable: true, thStyle:  {width: '10%'}},
                /* { key: 'ethnic_fund_type', label: 'Ethnic Fund Type', sortable: true, thStyle:  {width: '5%'}},
                { key: 'ethnic_fund_amount', label: 'Ethnic Fund Amount', sortable: true, thStyle:  {width: '5%'}},
                { key: 'sinda', label: 'Sinda', sortable: true, thStyle:  {width: '5%'}},
                { key: 'mbmf', label: 'Mbmf', sortable: true, thStyle:  {width: '5%'}},
                { key: 'cdac', label: 'Cdac', sortable: true, thStyle:  {width: '5%'}},
                { key: 'ecf', label: 'Ecf', sortable: true, thStyle:  {width: '5%'}},
                { key: 'other_fund', label: 'Other Fund', sortable: true, thStyle:  {width: '5%'}},
                { key: 'sdl_amount', label: 'Sdl Amount', sortable: true, thStyle:  {width: '5%'}},
                { key: 'employee_cpf', label: 'Employee Cpf', sortable: true, thStyle:  {width: '5%'}},
                { key: 'employer_cpf', label: 'Employer Cpf', sortable: true, thStyle: { width: '5%' } }, */
                { key: 'basic_wage', label: 'Basic Wage', sortable: true, thStyle: { width: '5%' } },
                { key: 'incentive', label: 'Incentive', sortable: true, thStyle: { width: '5%' } },
                { key: 'referral', label: 'Referral', sortable: true, thStyle: { width: '5%' } },
                { key: 'camp_amount', label: 'Camp Amount', sortable: true, thStyle: { width: '5%' } },
                { key: 'others', label: 'Others', sortable: true, thStyle: { width: '5%' } },
                { key: 'debit', label: 'Debit', sortable: true, thStyle: { width: '5%' } },
                { key: 'credit', label: 'Credit', sortable: true, thStyle: { width: '5%' } },
                { key: 'insurance_amount', label: 'Insurance Amount', sortable: true, thStyle: { width: '5%' } },
                { key: 'penalty_waiver', label: 'Penalty Waiver', sortable: true, thStyle: { width: '5%' } },
                { key: 'signup_bonus', label: 'Signup Bonus', sortable: true, thStyle: { width: '5%' } },
                { key: 'cash_advance', label: 'Cash Advance', sortable: true, thStyle: { width: '5%' } },
                { key: 'balance', label: 'Balance', sortable: true, thStyle: { width: '5%' } },
                { key: 'amount', label: 'Amount', sortable: true, thStyle: { width: '5%' } },
                { key: 'net_payout', label: 'Net Payout', sortable: true, thStyle: { width: '5%' } },
                { key: 'created_at', label: 'Created At', sortable: true, formatter: 'formatDate', thStyle: { width: '20%' } },
                { key: 'updated_at', label: 'Updated At', sortable: true, formatter: 'formatDate', thStyle: { width: '20%' } },
                /* { key: 'second_cpf_deduction', label: 'Second CPF Deduction', sortable: true, thStyle: { width: '5%' } },
                { key: 'final_amount', label: 'Final Amount', sortable: true, thStyle: { width: '5%' } } */
            ],
            form: {
                rowsPerPage: 25,
                userServices: 'all',
            },
            items: [],
            transactions:null,
            userDetail:null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 75, 100],
            sortBy: null,
            sortDirection: 'asc',
            filter: null,
            status: 'active',
            isBusy: false,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            to: '',
            from: '',
            country:'',
            countries:'',
            Country:'',
            webUrl: process.env.MIX_APP_URL,
            id: this.$route.params.id,
            payslip:''

        }
    },
    filters: {
        capitalize: function(value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        filtercapitalize:function(value){
          if (!value) return ''
          value = value.toString()
          value = value.replace('_',' ');
          return value.charAt(0).toUpperCase() + value.slice(1)
        },
        
        moment: function(date) {
          if (date == null || date == "") return "-";
            return moment(date).format('DD MMM, YYYY hh:mm A')
        },
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        formatDate(value) {
            if (!value) return '—';
            const date = new Date(value);
            return date.toLocaleDateString('en-SG', {
                year: 'numeric',
                month: 'short',
                day: '2-digit'
            });
        },
        getDetail() {
            return this.$store.dispatch(POST_API, {
                    data: {
                        page: this.currentPage,
                        keyword: this.filter,
                        rowsPerPage: this.form.rowsPerPage,
                        sortBy: this.sortBy,
                        sortDirection: this.sortDirection,
                        sortDesc: this.sortDesc,
                        user_id:Vue.prototype.decrypt(this.$route.params.user_id),
                        payslip_id:Vue.prototype.decrypt(this.$route.params.payslip_id),
                        date:this.$route.params.date,

                    },
                    api: '/api/jobseeker-payslip-logs'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;
                        this.showAlert();
                        return [];
                    } else {
                        this.items = this.$store.getters.getResults.data;
                        this.payslip = this.$store.getters.getResults.payslip;
                        console.log("this.items", this.items); //debug
                        console.log("this.items.length", this.items.length); //debug
                        
                        return this.items;
                    }
                });
        },

        
    },
    mounted() {
        this.getDetail();
    }

}

</script>
